import { DateTime } from "luxon"

export type Survey = Readonly<{
    id: number
    description: string
    title: string
    isActive: boolean
    type: string
    visibleForProductsIds: number[]
    hideAfterDays: number
    questions: SurveyQuestion[]
    activePeriod: MerchantSurveyActivePeriod
}>

export type MerchantSurveyActivePeriod = Readonly<{
    from: {
        date: string
    }
    to?: {
        date: string | null
    }
}>
export enum SurveyTypeOptions {
    SMILEY = "SMILEY",
}

export type MerchantSurveyUserCardDetails = Readonly<{
    visibility: {
        timeOfDay?: string | null
        expirationDays: number
    }
}>

export type SurveyQuestion = Readonly<{
    title: string
    id: number
    [TopicType.GOOD_TOPICS]: TopicItemForMerchant[]
    [TopicType.BAD_TOPICS]: TopicItemForMerchant[]
}>

export type MerchantSurvey = Readonly<{
    id?: number
    description: string
    title: string
    isActive: boolean
    card: MerchantSurveyUserCardDetails
    activePeriod: MerchantSurveyActivePeriod
    questions: SurveyQuestion[]
    type?: SurveyTypeOptions | string
    merchant?: {
        id: number
    }
}>

export type CreateOrEditSurveyFormValues = Readonly<{
    title: string
    description: string
    isActive: boolean
    questions: SurveyQuestion[]
    card: {
        visibility: {
            timeOfDay: DateTime | null
            expirationDays: number
        }
    }
    activePeriod: {
        from: {
            date: DateTime
        }
        to: {
            date: DateTime | null
        }
    }
}>

// TOPICS LIST
export enum TopicType {
    GOOD_TOPICS = "goodTopics",
    BAD_TOPICS = "badTopics",
}
export type TopicItemForMerchant = Readonly<{
    id: number
    value: string
}>

export type TopicsListForMerchant = Readonly<{
    [TopicType.GOOD_TOPICS]: TopicItemForMerchant[]
    [TopicType.BAD_TOPICS]: TopicItemForMerchant[]
}>
